/**
 * Module dependencies.
 */

import { Description } from 'components/atoms/description/description';
import { Title } from 'components/atoms/title/title';
import styled from '@emotion/styled';

/**
 * Export `StyledTitle` styled component.
 */

export const StyledTitle = styled(Title)`
  text-align: center;
  margin-top: 60px;
`;

/**
 * Export `StyledDescription` styled component.
 */

export const StyledDescription = styled(Description)`
  text-align: center;
`;
